import type { TipsConfig } from '@Interfaces/Constants/DataInterface'
import type { SubMenuItem } from '@Interfaces/Component/SubMenuInterface'
import type { Org } from '@Interfaces/Data/OrganizationInterface'
import { COMMUNITY_TIPS, NONPROFIT_TIPS, TIPS } from '@utils/appData/appData'
import { Links } from '@utils/links'

export const SIDEBAR_TIP_STEP = 'sidebar' as const

const KNOWN_ORG_TYPES = new Set(['community', 'nonprofit', 'business'])

const EMPTY_TIPS = {} as const satisfies Partial<TipsConfig>

export function resolveTipsConfigForOrg(selectedOrg: Org | null): Partial<TipsConfig> {
  const t = selectedOrg?.type
  if (!t || !KNOWN_ORG_TYPES.has(t)) return EMPTY_TIPS
  if (t === 'community') return COMMUNITY_TIPS
  if (t === 'business') return TIPS
  return NONPROFIT_TIPS
}

export function includeSidebarNavItem(
  path: string | undefined,
  selectedOrg: Org | null,
  userType: string
): boolean {
  if (!path || !selectedOrg) return false
  if (path === Links.Settings && userType !== 'Leader') return false
  if (path === Links.Donations && selectedOrg.type !== 'nonprofit') return false
  if (path === Links.Fundraising && selectedOrg.type !== 'nonprofit') return false
  if (
    path === Links.Nonprofits &&
    selectedOrg.type === 'business' &&
    !selectedOrg.stripeComplete
  )
    return false
  return true
}

export function filterVisibleSidebarNavItems(
  navItems: SubMenuItem[],
  selectedOrg: Org | null,
  userType: string
): SubMenuItem[] {
  return navItems.filter((item) => includeSidebarNavItem(item.path, selectedOrg, userType))
}

export function getVisibleSidebarTipSteps(
  visibleNavItems: SubMenuItem[],
  tipsConfig: Partial<TipsConfig>
): string[] {
  if (!tipsConfig.sidebar) return []
  const steps: string[] = [SIDEBAR_TIP_STEP]
  for (const item of visibleNavItems) {
    if (!item.path || !tipsConfig[item.path]) continue
    steps.push(item.path)
  }
  return steps
}

export function resolveTourNavigateTarget(
  nextPathOverride: string | null | undefined,
  finishLike: boolean,
  tipNextPath: string | undefined
): string | undefined {
  if (nextPathOverride != null) return nextPathOverride
  if (nextPathOverride === null && finishLike) return undefined
  return tipNextPath
}
